/**
 * SkipToContent Component
 * 
 * Provides skip links for keyboard navigation:
 * - Skip to main content
 * - Skip to table (if present)
 */

import * as React from 'react'
import { cn } from '../utils'
import { semanticTokens } from '@packages/config/theme'

export interface SkipToContentProps extends React.HTMLAttributes<HTMLAnchorElement> {
  skipToTable?: boolean
}

export function SkipToContent({ skipToTable = false, className, ...props }: SkipToContentProps) {
  return (
    <div className="sr-only focus-within:not-sr-only focus-within:absolute focus-within:z-50 focus-within:top-2 focus-within:left-2">
      <a
        href="#main"
        data-skip-link
        className={cn(
          'inline-block px-4 py-2 rounded-md',
          semanticTokens.bg.surface,
          semanticTokens.border.default,
          semanticTokens.fg.default,
          semanticTokens.focus.ring,
          semanticTokens.motion.micro,
          className
        )}
        {...props}
      >
        Skip to main content
      </a>
      {skipToTable && (
        <a
          href="#table-content"
          data-skip-link
          className={cn(
            'inline-block px-4 py-2 rounded-md ml-2',
            semanticTokens.bg.surface,
            semanticTokens.border.default,
            semanticTokens.fg.default,
            semanticTokens.focus.ring,
            semanticTokens.motion.micro,
            className
          )}
        >
          Skip to table
        </a>
      )}
    </div>
  )
}

